import { useState, useEffect } from "react"
import Select from 'react-select';

const CboPeriodos = ({ selectedValue, onChange, disabled, grupo, empresa, tipoliq, className }) => {



  const [periodos, setPeriodos] = useState([])

  useEffect(() => {

    if (tipoliq) {

      var json3;
      var jsons3;
      var url3;
      let consulta = new Object();

      consulta.grupo = grupo;
      consulta.empresa = empresa;
      consulta.tipoliq = tipoliq;

      jsons3 = JSON.stringify(consulta);
      console.log("Períodos input -", consulta);

      var options3 = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'

        },
        mode: 'cors',
        credential: 'include',
        body: jsons3,

      };

      url3 = `${process.env.REACT_APP_API_URL}/per/allperiodos`;



      fetch(url3, options3)
        .then(response => response.json())
        .then(data => {

          json3 = data;

          console.log("Períodos ", json3.data);

          if (json3.data.length > 0) {
            setPeriodos(json3.data);
            var primerId;
            if (selectedValue) {
              primerId = selectedValue;
            }
            else {
              primerId = json3.data[0].Per_IdPer;
            }
            // Creamos un objeto que simule el evento de cambio para no romper la lógica del componente padre
            const eventoSimulado = {
              target: {
                value: primerId
              }
            };
            onChange(eventoSimulado);
          }




        })

    }
  }, [empresa, tipoliq]);

  const opciones = [
    { value: 0, label: "" },

    ...periodos.map((unolista) => ({
      value: unolista.Per_IdPer,
      label: unolista.Per_Nombre
    }))
  ];

  return (
    <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4">
      <div className="form-group">
        <label className="l" >Período de Liquidación</label>
        <Select
          className={className}
          classNamePrefix="miSelect"

          value={opciones.find(op => op.value == selectedValue)}

          onChange={(op) =>
            onChange({
              target: {
                value: op.value
              }
            })
          }

          options={opciones}

          isDisabled={disabled}

          isSearchable={false}
        />

      </div>
    </div>
  );
};

export default CboPeriodos;